<template>
  <div>
    <article>
      <header>
        <h2>{{ totalOffers }} Angebote</h2>
      </header>
      <main>
        <div v-for="offer in offers" class="offer">
          <div>{{ offer.ticket.ticketId }}</div>
          <div>{{ offer.name }}</div>
          <div>{{ offer.email }}</div>
          <div>{{ offer.iban }}</div>
          <button class="silent" v-if="!offer.approved" @click="approved(offer)">IBAN als gültig markieren</button>
          <button class="silent" v-else-if="!offer.payedOffer" @click="payedOffer(offer)">Anbieter als ausgezahlt markieren</button>
          <button class="silent" v-else-if="!offer.payedReceiver" @click="payedReceiver(offer)">Ticket als vergeben markieren</button>
          <div v-else>Abgeschlossen</div>
        </div>
      </main>
    </article>
    <article class="secondary">
      <header>
        <h2>{{ totalRequests }} Anfragen</h2>
      </header>
      <main>
        <div v-for="request in requests" class="request">
          <div style="width: 120px">
            <i class="material-icons" v-for="i in request.amount">local_activity</i>
          </div>
          <div>{{ request.email }}</div>
          <button class="silent" v-if="!request.notified" @click="notified(request)">Nutzer als informiert markieren</button>
          <button class="silent" v-else-if="!request.fulfilled" @click="fulfilled(request)">Anfrage als abgeschlossen markieren</button>
          <div v-else>Abgeschlossen</div>
        </div>
      </main>
    </article>
  </div>
</template>
<script>
  const axios = require('axios');
  export default {
    data() {
      return {
        offers: [],
        requests: []
      }
    },
    computed: {
      totalOffers() {
        let counter = 0;
        for (let i = 0; i < this.offers.length; i++) {
          if (this.offers[i].payedReceiver) continue;
          counter += 1;
        }
        return counter;
      },
      totalRequests() {
        let counter = 0;
        for (let i = 0; i < this.requests.length; i++) {
          if (this.requests[i].fulfilled) continue;
          counter += this.requests[i].amount;
        }
        return counter;
      }
    },
    mounted() {
      this.loadOffers();
      this.loadRequests();
    },
    methods: {
      apiGet(request, callback) {
        const credentials = JSON.parse(localStorage.getItem('API_CREDENTIALS'));
        if (!credentials) {
          this.$router.push({name: 'ticket'});
        }
        axios.get(`${process.env.VUE_APP_API}/${request}`, {
          headers: {
            Authorization: `Bearer ${credentials.auth.access_token}`
          }
        }).then(response => {
          callback(response);
        }).catch(err => {
          this.$router.push({name: 'ticket'});
        })
      },
      apiPost(request, data, callback) {
        const credentials = JSON.parse(localStorage.getItem('API_CREDENTIALS'));
        if (!credentials) {
          this.$router.push({name: 'ticket'});
        }
        axios.post(`${process.env.VUE_APP_API}/${request}`, data, {
          headers: {
            Authorization: `Bearer ${credentials.auth.access_token}`
          }
        }).then(response => {
          callback(response);
        }).catch(err => {
          this.$router.push({name: 'ticket'});
        })
      },
      approved(offer) {
        const change = { approved: true };
        this.apiPost(`admin/tickets/offer/${offer._id}`, change, response => {
          this.offers = [...this.offers.map(off => off._id === offer._id ? {...off, ...change} : off)];
        });
      },
      fulfilled(request) {
        const change = { fulfilled: true };
        this.apiPost(`admin/tickets/request/${request._id}`, change, response => {
          this.requests = [...this.requests.map(req => req._id === request._id ? {...req, ...change} : req)];
        });
      },
      notified(request) {
        const change = { notified: true };
        this.apiPost(`admin/tickets/request/${request._id}`, change, response => {
          this.requests = [...this.requests.map(req => req._id === request._id ? {...req, ...change} : req)];
        });
      },
      payedOffer(offer) {
        const change = { payedOffer: true };
        this.apiPost(`admin/tickets/offer/${offer._id}`, change, response => {
          this.offers = [...this.offers.map(off => off._id === offer._id ? {...off, ...change} : off)];
        });
      },
      payedReceiver(offer) {
        const change = { payedReceiver: true };
        this.apiPost(`admin/tickets/offer/${offer._id}`, change, response => {
          this.offers = [...this.offers.map(off => off._id === offer._id ? {...off, ...change} : off)];
        });
      },
      loadOffers() {
        this.apiGet('admin/tickets/offer', response => {
          this.offers = response.data;
        });
      },
      loadRequests() {
        this.apiGet('admin/tickets/request', response => {
          this.requests = response.data;
        });
      }
    }
  }
</script>
<style scoped lang="scss">
  .offer, .request {
    display: flex;
    margin-bottom: 10px;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }

    > * {
      width: 100%;
    }

    > div {
      padding-right: 10px;
      text-align: left;

      &:last-child {
        padding-right: 0;
      }
    }
  }
</style>
